import {css} from 'emotion';

const contentDrawer = css`
  && {
    width: 495px;
    margin: 7px 0 0 0 ;
    max-height: 353px;
  }
`;

const heightOfWindow = window.innerHeight;
const heightOfMobileCancelButton = 100;

const mobileContainer = css`
  height: ${heightOfWindow - heightOfMobileCancelButton}px;
`;

export default {
  contentDrawer,
  mobileContainer,
};
